import { isPromise } from '@dimjs/lang';
import { hooks } from '@wove/react';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { AutoCenter } from '../../auto-center';
import { ModalConfirm, ModalConfirmProps } from '../../modal-confirm';
import { bodyAppendDivElement, BodyAppendDivElementProps, removeBodyChild } from '../../utils';

export type TDialogConfirmProps = Omit<
  ModalConfirmProps,
  'visible' | 'getContainer' | 'onClose' | 'onClick' | 'destroyOnClose' | 'children'
> & {
  content: string | JSX.Element;
};

const ModalRender = (props: TDialogConfirmProps & BodyAppendDivElementProps) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  const onClose = () => {
    setVisible(false);
  };

  const onCancel = hooks.useCallbackRef(() => {
    if (props.onCancel) {
      const response = props.onCancel();
      if (response && isPromise(response)) {
        return response.then(() => {
          onClose();
        });
      }
    }
    onClose();
    return;
  });

  const onOK = hooks.useCallbackRef(() => {
    if (props.onOK) {
      const response = props.onOK();
      if (response && isPromise(response)) {
        return response.then(() => {
          onClose();
        });
      }
    }
    onClose();
    return;
  });

  const onAfterClose = hooks.useCallbackRef(() => {
    removeBodyChild(`#${props.elementId}`);
    props.onAfterClose?.();
  });

  return (
    <ModalConfirm
      {...props}
      visible={visible}
      getContainer={props.divElement}
      onOK={onOK}
      onCancel={onCancel}
      onClose={onClose}
      onAfterClose={onAfterClose}
      destroyOnClose={true}
    >
      <AutoCenter>{props.content}</AutoCenter>
    </ModalConfirm>
  );
};

export const dialogConfirm = (props: TDialogConfirmProps) => {
  const { divElement, elementId } = bodyAppendDivElement();
  ReactDOM.render(<ModalRender {...props} divElement={divElement} elementId={elementId} />, divElement);
};
